module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-07.ffc60295.png";